import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { FileText, Search, Download } from "lucide-react";

const CATS = ["","Policy","Guideline","Circular","SOP","Template","Technical","Office Order","Drawing"];

export default function KnowledgePage() {
  const [items, setItems] = useState([]);
  const [cat, setCat] = useState("");
  const [q, setQ] = useState("");
  useEffect(() => {
    const params = new URLSearchParams();
    if (cat) params.set("category", cat);
    if (q) params.set("q", q);
    api.get(`/knowledge?${params.toString()}`).then((r)=>setItems(r.data.items));
  }, [cat, q]);

  return (
    <div className="space-y-6">
      <div>
        <div className="label-tiny text-[hsl(var(--primary))]">Knowledge Management</div>
        <h1 className="mt-1 text-3xl font-heading font-bold">PEDA Knowledge Base</h1>
        <p className="text-sm text-muted-foreground mt-1">Policies · Circulars · Office Orders · Drawings · Templates</p>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <div className="flex flex-wrap gap-2">
          {CATS.map((c) => (
            <button key={c || "all"} onClick={()=>setCat(c)} className={`px-3 py-1.5 rounded-full text-xs border ${cat === c ? "bg-[hsl(var(--primary))] text-white border-transparent" : "border-border hover:bg-muted"}`}>{c || "All"}</button>
          ))}
        </div>
        <div className="ml-auto flex items-center gap-2 rounded-full border border-border px-3 py-1.5 bg-muted/40 min-w-[240px]">
          <Search className="h-4 w-4 opacity-60"/>
          <input value={q} onChange={(e)=>setQ(e.target.value)} placeholder="Search documents…" className="bg-transparent outline-none text-sm w-full"/>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((d) => (
          <div key={d.id} className="rounded-xl border border-border bg-card p-5 hover:-translate-y-0.5 transition-transform">
            <div className="flex items-center gap-2">
              <div className="h-9 w-9 rounded-md bg-[hsl(var(--primary))]/10 text-[hsl(var(--primary))] grid place-items-center"><FileText className="h-4 w-4"/></div>
              <div className="text-[10px] uppercase tracking-widest text-muted-foreground">{d.type}</div>
              <div className="ml-auto text-[10px] text-muted-foreground">{d.version}</div>
            </div>
            <div className="mt-3 font-heading font-semibold text-sm leading-tight">{d.title}</div>
            <div className="text-xs text-muted-foreground mt-1">{d.category} · {d.size_kb} KB · {d.created_at}</div>
            <button className="mt-4 btn-outline text-xs w-full"><Download className="h-3.5 w-3.5"/>Download</button>
          </div>
        ))}
      </div>
    </div>
  );
}
